module.exports = __webpack_public_path__ + "img/sicbo.3bab334d.png";